import React from 'react';
import './aim-animated-background.styles.css';

const AimAnimatedBackground = ({
  variant = 'blue',
  height = '400px',
  className = '',
  customColors = null
}) => {
  const sectionClasses = `aim-animated-bg aim-animated-bg--${variant} ${className}`;

  return (
    <div className="absolute inset-0 w-full z-0 pointer-events-none" style={{ height }}>
      <div
        className={sectionClasses}
        style={
          customColors
            ? {
                '--primary-color': customColors.primary,
                '--secondary-color': customColors.secondary,
                '--accent-color': customColors.accent
              }
            : {}
        }
      />
    </div>
  );
};

export default AimAnimatedBackground;
